import { makeStyles } from 'tss-react/mui';
import { Typography, Container, Button, Grid } from '@mui/material';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { useContext } from 'react';
import { appUserContext } from 'helpers/services';
import { UserTypology } from 'helpers/Enums';


let useStyles = makeStyles()(() => ({
    homepage: {
        position: 'fixed',
        width: '100%',
        height: '100%',
        left: 0,
        right: 0,
        backgroundColor: '#FFF',
        backgroundPosition: 'right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain'
    },
    container: {
        marginTop: '16%'
    }
}));

let Homepage = () => {
    let { classes } = useStyles();

    let { formatMessage } = useIntl();
    let { currentUser } = useContext(appUserContext);


    return (
        <div className={classes.homepage}>
            <Container
                maxWidth="md"
                className={classes.container}
            >
                <Typography
                    align="center"
                    variant="h1"
                >
                    {formatMessage({ id: LocalizationIds.WelcomeTo })}&nbsp;My Simec
                </Typography>
                <Typography align="center" variant="subtitle2">
                    {formatMessage({ id: LocalizationIds.ChooseMenuAction })}
                </Typography>

                <Grid container>
                    <Grid item xs={12} />
                    <Grid item xs={12} />
                    <Grid item xs={12} />
                    <Grid item xs={12} />

                    {currentUser.typology === UserTypology.Simec && currentUser.simecClaims.canCreateTicket === false &&
                        <Grid item xs={12} md lg></Grid>
                    }
                    {(currentUser.typology !== UserTypology.Simec || currentUser.simecClaims.canCreateTicket) &&
                        <Grid item xs={12} md lg>
                            <Button
                                component={RouterLink}
                                to={currentUser.typology === UserTypology.Customer ? '/customer/ticket/addnew' : '/ticket/addnew'}
                                fullWidth
                                variant='contained'
                                color='secondary'
                            >
                                {formatMessage({ id: LocalizationIds.OpenNewTickets })}
                            </Button>
                        </Grid>
                    }

                    <Grid item xs={12} md lg>
                        <Button
                            component={RouterLink}
                            to={currentUser.typology === UserTypology.Customer ? '/customer/tickets' : '/tickets'}
                            fullWidth
                            variant='contained'
                            color='secondary'
                        >
                            {formatMessage({ id: LocalizationIds.ViewTickets })}
                        </Button>
                    </Grid>

                    {currentUser.typology === UserTypology.Simec && currentUser.simecClaims.canCreateTicket === false &&
                        <Grid item xs={12} md lg></Grid>
                    }
                </Grid>
            </Container>
        </div>
    );
}

export default Homepage;